import { FC, Fragment, useContext, useEffect, useState } from 'react';
import SelectCustom from 'components/ui/SelectCustom/SelectCustom';
import Button from 'components/ui/Button/Button';
import { getCurrency, formatPriceCurrency, getLogoUrl } from 'utils/utils';
import { RoundTripMode, roundTripModes, token } from 'constants/flight';
import { FlightsResultContext } from 'contexts/FlightsResultContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import FlightTicket from './FlightTicket';
import { useTranslation } from 'react-i18next';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { blobUrl } from 'constants/generic';

interface RoundTripProps {
  onChangeMode: (mode: RoundTripMode) => void;
  onClickContinue: () => void;
}
const RoundTrip: FC<RoundTripProps> = (props) => {
  const [t] = useTranslation();
  
  const [mode, setMode] = useState(RoundTripMode.Default);
  const [showInbound, setShowInbound] = useState(false);
  const [showOutbound, setShowOutbound] = useState(false);

  const flightContext = useContext(FlightsResultContext);

  useEffect(() => {
    setMode(flightContext?.roundTripMode || RoundTripMode.Default);
  }, [flightContext?.roundTripMode]);

  const onChange = (value: RoundTripMode) => {
    setMode(value);
    props.onChangeMode(value);
  };

  return (
    <Fragment>
      <div className="bound">
        <SelectCustom
          options={roundTripModes}
          value={mode}
          onChange={onChange}
          needToTranslate={true}
        />
      </div>
      {(!!flightContext?.outboundFlight || !!flightContext?.inboundFlight) && (
        <div className="bound-choosen">
          {!!flightContext?.outboundFlight && (
            <div
              className="flex-row bound-button default-shadow"
              onMouseEnter={() => setShowOutbound(true)}
              onMouseLeave={() => setShowOutbound(false)}
            >
              <div>
                <div className="mb-3">{t('flight.outbound')}</div>
                <div className="text-bold">
                  {formatPriceCurrency(
                    flightContext.outboundFlight.flighPrice.grossAndTaxWithMarkup.value,
                    getCurrency(
                      flightContext.outboundFlight.flighPrice.grossAndTaxWithMarkup.currency
                    )
                  )}
                </div>
              </div>
              <img src={getLogoUrl(blobUrl, flightContext.outboundFlight.airlineCode)} alt="" />
              <FontAwesomeIcon
                className="fa-times"
                icon={faTimes as any}
                onClick={() => {
                  setShowOutbound(false);
                  flightContext.setOutboundFlight(undefined);
                }}
              />
              {showOutbound && (
                <div className="bound-button-ticket">
                  <FlightTicket
                    flight={flightContext.outboundFlight}
                    sessionStorageKey={token.outbound}
                  />
                </div>
              )}
            </div>
          )}
          {!!flightContext?.inboundFlight && (
            <div
              className="flex-row bound-button default-shadow"
              onMouseEnter={() => setShowInbound(true)}
              onMouseLeave={() => setShowInbound(false)}
            >
              <div>
                <div className="mb-3">{t('flight.inbound')}</div>
                <div className="text-bold">
                  {formatPriceCurrency(
                    flightContext.inboundFlight.flighPrice.grossAndTaxWithMarkup.value,
                    getCurrency(
                      flightContext.inboundFlight.flighPrice.grossAndTaxWithMarkup.currency
                    )
                  )}
                </div>
              </div>

              <img src={getLogoUrl(blobUrl, flightContext.inboundFlight.airlineCode)} alt="" />
              <FontAwesomeIcon
                className="fa-times"
                icon={faTimes as any}
                onClick={() => {
                  setShowInbound(false);
                  flightContext.setInboundFlight(undefined);
                }}
              />
              {showInbound && (
                <div className="bound-button-ticket">
                  <FlightTicket
                    flight={flightContext.inboundFlight}
                    sessionStorageKey={token.inbound}
                  />
                </div>
              )}
            </div>
          )}
          {!!flightContext?.inboundFlight && !!flightContext?.outboundFlight && (
            <Button
              title={t('choose')}
              className="btn btn-primary ml-10"
              onClick={props.onClickContinue}
            />
          )}
        </div>
      )}
    </Fragment>
  );
};

export default withErrorBoundary(RoundTrip, 'RoundTrip');
